import { CmdDevaluationProduct } from "./CmdDevaluationProduct";

export class CmdDevaluationTableData {
    productTitle: string;
    productAnnualAverage: string;
    productData: Array<CmdDevaluationProduct> = [];
}